// PRODUCTION
// DEVELOPMENT
const SHARGO_URL = 'https://api-sandbox.shargo.io/v1/'
const SHARGO_API =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyaWQiOiI1YWRlZTg4ZGMyMjI5ODEwMDBkYTIzMDAiLCJpYXQiOjE1MjQ1NTc5NjYsImV4cCI6MTYxOTE2NTk2Nn0.6JSC_rVCzqZHKe6igJJ7LjHLgMNGNa-yTMN_z-L_Ha0'
export default {
  companyName: 'IMM DELIVERY',
  firebase: {
    apiKey: 'AIzaSyBiRxcJkMaws6WAa7Jq0n13fXA1sNRjFR4',
    authDomain: 'imm-delivery.firebaseapp.com',
    databaseURL: 'https://imm-delivery.firebaseio.com',
    projectId: 'imm-delivery',
    storageBucket: 'imm-delivery.appspot.com',
    messagingSenderId: '849096197547'
  },
  baseApiUrl: SHARGO_URL,
  headers: {
    Authorization: SHARGO_API,
    'Content-Type': 'application/json'
  }
}



// WEBPACK FOOTER //
// ./src/config.js